import PropTypes from 'prop-types';

const HorizontalListString = ({items, separator}) =>
    items.join(` ${separator} `);

HorizontalListString.propTypes = {
    /** List of elements to display in the list */
    items: PropTypes.arrayOf(PropTypes.string),
    /** String to be placed in between the items list */
    separator: PropTypes.string,
};

HorizontalListString.defaultProps = {
    items: [],
    separator: '·',
};

export default HorizontalListString;
